import React from 'react';
import PropTypes from 'prop-types';

const Progress = ({
  value,
  color,
  height,
  className = '',
  style = {}
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `progress ${className}`,
    style: {
      height,
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress__bar",
    style: {
      width: `${value}%`,
      backgroundColor: color,
      height
    }
  }));
};

Progress.propTypes = {
  value: PropTypes.number.isRequired,
  color: PropTypes.string,
  height: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
};
export default Progress;